"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const mui_1 = require("tss-react/mui");
const accounts_1 = require("companion-app-components/flux/accounts");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const selectors_1 = require("data/datasetSharing/selectors");
const empty_account_group_svg_1 = __importDefault(require("assets/zero-state-images/empty-account-group.svg"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const EmptyEntityPage = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { classes } = useStyles();
    const isCurrentDatasetOwner = (0, react_redux_1.useSelector)(selectors_1.getIsCurrentDatasetOwner);
    const accountsLoadPending = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getLoadPending);
    const accountsById = (0, react_redux_1.useSelector)(accounts_1.accountsSelectors.getAccountsById);
    const selectedAccountGroupName = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.getCurrentAccountGroupName);
    if (!accountsLoadPending && (accountsById === null || accountsById === void 0 ? void 0 : accountsById.size) >= 1) {
        navigate('/', { replace: true });
    }
    return (<Box_1.default className={classes.root}>
      <Box_1.default className={classes.content}>
        <img className={classes.image} src={empty_account_group_svg_1.default} alt="No accounts assigned"/>
        <Typography_1.default variant="h5" className={classes.title}>
          {isCurrentDatasetOwner ? 'No accounts assigned' : 'No accounts shared'}
        </Typography_1.default>
        {isCurrentDatasetOwner ? (<>
            <Typography_1.default variant="body1" className={classes.body}>
              You haven&apos;t assigned any accounts to your{' '}
              <span className={classes.entityName}>{selectedAccountGroupName || ''}</span> entity.
            </Typography_1.default>
            <Typography_1.default variant="body1" className={classes.body}>
              To assign accounts, open Quicken on your desktop and go to: <br />
              <Box_1.default component="span" fontWeight={500}>Tools &gt; Entity Management...</Box_1.default>
            </Typography_1.default>
          </>) : (<Typography_1.default variant="body1" className={classes.body}>
            The owner hasn&apos;t shared any accounts yet.
          </Typography_1.default>)}

      </Box_1.default>
    </Box_1.default>);
};
exports.default = EmptyEntityPage;
